
import { Header } from './component/Header';
import { Cards } from './component/Cards';
import './App.css';
import { Footer } from './component/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Cards />
      <Footer />
    </div>
  );
}

export default App;
